import { GraphQLClient } from "graphql-request";
import { graphqlRequestBaseQuery } from "@rtk-query/graphql-request-base-query";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import posthog from "posthog-js";
import { posthogApiKey } from "@/config/posthog";

import { RootState } from "@/store";
import { gqlMockServerURL, gqlServerURL } from "@/config";

// Type assertion needed due to graphql-request v6 ESM/legacy build type mismatch
// with @rtk-query/graphql-request-base-query's bundled types
export const mockClient = new GraphQLClient(gqlMockServerURL) as any;
export const client = new GraphQLClient(gqlServerURL, {
  credentials: "include",
}) as any;

interface FetchBaseQueryError {
  status: number;
  data: any;
  error?: string;
}

export const baseQuery: BaseQueryFn<
  { document: string; variables?: any },
  any,
  FetchBaseQueryError,
  object,
  object
> = graphqlRequestBaseQuery({
  client,
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    const token = state.auth.accessToken;
    if (token) {
      headers.set("Authorization", token);
    }
    return headers;
  },
  customErrors: (error) => {
    if (posthogApiKey) {
      posthog.capture("$exception", {
        $exception_message: error.message,
        $exception_type: "GraphQLError",
        $exception_source: "base-query",
      });
    }

    if (error.response?.errors) {
      const formattedErrors = error.response.errors
        .map((err: { message: string }) => err.message)
        .join(", ");
      throw new Error(formattedErrors);
    }
    throw new Error(`Network Error: ${error.message}`);
  },
});

export const baseQueryMock: BaseQueryFn<
  { document: string; variables?: any },
  any,
  FetchBaseQueryError,
  object,
  object
> = graphqlRequestBaseQuery({
  client: mockClient,
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    const token = state.auth.accessToken;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }

    return headers;
  },
  customErrors: (error) => {
    if (error.response?.errors) {
      const formattedErrors = error.response.errors
        .map((err) => err.message)
        .join(", ");
      throw new Error(formattedErrors);
    }
    throw new Error(`Network Error: ${error.message}`);
  },
});
